import React from 'react';
export function Story() {
  return <section className="w-full bg-cream-deep" data-id="element-91" data-mp="2smy6sawlfj4q">
      <div className="mx-auto max-w-5xl px-6 py-20 md:py-28" data-id="element-92" data-mp="1ic5i750czbwn">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-93" data-mp="1iac81fqje9jw">
          <div className="lg:col-span-5" data-id="element-94" data-mp="1n4gjab6u53qs">
            <h2 className="font-serif text-4xl leading-[1.05] text-terracotta md:text-5xl" data-id="element-95" data-mp="1s28ilq9t7s50">
              Por qué lo hago a esta edad
            </h2>

            <figure className="mt-8" data-id="element-96" data-mp="ufrm2n8whikb">
              <img src="https://cdn.magicpatterns.com/uploads/96yuMESnjPv5crPQ9Bp16J/IMG_7167.jpg" alt="Retrato de Liza al aire libre, al atardecer" className="aspect-[4/5] w-full rounded-2xl border border-ink-line object-cover" loading="lazy" data-id="element-97" data-mp="ugt112t1ep7b" />
              <figcaption className="mt-3 text-sm text-ink-faint" data-id="element-98" data-mp="2fscax1hjs5gp">
                Liza · 52 años · Venezolana
              </figcaption>
            </figure>
          </div>

          <div className="space-y-6 text-lg leading-relaxed text-ink md:text-xl lg:col-span-7 lg:pt-2" data-id="element-99" data-mp="2jv8zd8trqvsk">
            <p className="font-serif text-2xl leading-snug text-ink md:text-3xl" data-id="element-100" data-mp="142ywqf1ya1n8">
              Me llamo Liza. Tengo 52 años. Hace poco aprendí IA.
            </p>
            <p data-id="element-101" data-mp="z2awd2ru08gc">No soy millonaria. No soy influencer. Soy trabajadora. Como tú.</p>
            <p data-id="element-102" data-mp="v1ily6783xih">
              Cuando descubrí ChatGPT, Claude y Gemini, algo hizo click. Empecé a producir en 2
              horas lo que antes me llevaba 2 días.
            </p>
            <p data-id="element-103" data-mp="lc7fkrbq16ya">Eso no es suerte. Es que aprendí a usar bien estas herramientas.</p>
            <p data-id="element-104" data-mp="gd4knzpggh41">
              Mi meta ahora es simple: que 10,000 venezolanos aprendan esto. Porque quien domina la
              IA hoy va a estar años adelante mañana.
            </p>
            <p className="border-l-2 border-terracotta pl-6 text-ink" data-id="element-105" data-mp="7cpxsvwuetyf">
              Este curso cuesta $20 porque quiero que lo compres. No porque quiera tu dinero. Porque quiero que crezcas y me ayudes a crecer a mí también. En la unión está la fuerza, y Venezuela necesita gente preparada. 
            </p>
          </div>
        </div>
      </div>
    </section>;
}